<template>
  <div class="trend-container">
    <Head :Index="isIndex"/>
    <Banner :banner1="bannerObj1"/>
    <div class="auto_1280">
      <!-- <div class="box"> -->
        <TrendMenu/>
      <!-- </div> -->
    </div>
    <router-view/>
    <Bottom :Index="isIndex"/>
  </div>
</template>
<script>
import Head from '@/components/header'
import Banner from '@/components/banner'
import TrendMenu from '@/components/trendsmenu'
import Bottom from '@/components/bottom'
export default {
  components: {
    Head,
    Banner,
    TrendMenu,
    Bottom
  },
  data () {
    return {
      isIndex: false,
      columnId: this.$route.query.columnId,
      bannerObj1: {}
    }
  },
  mounted () {
    if (sessionStorage.getItem('banner') === null) {
      this.init()
    } else {
      try {
        const id = parseInt(this.$route.query.columnId) || parseInt(localStorage.getItem('columnId'))
        const banner = JSON.parse(sessionStorage.getItem('banner'))
        banner.forEach((item) => {
          if (item.articleTypeId === id) {
            this.bannerObj1 = item
          }
        })
      } catch (err) {
        console.log(err)
      }
    }
    // this.init()
  },
  methods: {
    init () {
      const id = parseInt(this.$route.query.columnId) || parseInt(localStorage.getItem('columnId'))
      this.$api.post('api/benefitAdvert/queryByParam', { isDelete: 0, state: 1 }, r => {
        r.data.forEach((item) => {
          if (item.articleTypeId === id) {
            this.bannerObj1 = item
          }
          if (!this.bannerObj1.id) {
            this.bannerObj1 = {
              img: require('@/assets/vlovemother-banner-pc.jpg'),
              img2: require('@/assets/vlovemother-banner-wap.jpg')
            }
          }
        })
        sessionStorage.setItem('banner', JSON.stringify(r.data))
      })
    }
  }
}
</script>
